import { Avatar, Card } from "antd";
import Meta from "antd/lib/card/Meta";
import { useSelector } from "react-redux";
import UserOutlined from "../../../../../../assets/images/UserOutlined.svg";
import Ellipsis from "../../../../../../common/components/views/Ellipsis";
import { getApiBaseUrl } from "../../../../../../common/utils/utils";
import { selectToken, selectUserAccount } from "../../../../../auth/ducks";
import { InternalDashboardContact } from "../../../../types";
import { DashboardContactFooterView } from "./DashboardContactFooterView";

interface Props {
  contact: InternalDashboardContact;
  children: React.ReactNode;
}

export const InternalDashboardContactView = ({ contact, children }: Props) => {
  const token = useSelector(selectToken);
  const userAccount = useSelector(selectUserAccount);

  return (
    <Card
      key={contact.id}
      styles={{ body: { padding: "14px 10px" } }}
      actions={[<DashboardContactFooterView email={contact.agent?.email} phone={contact.agent?.phone} />]}
    >
      <Meta
        avatar={
          contact.agent ? (
            <Avatar
              src={
                contact.agent.profilePicture ? (
                  <img
                    style={{ objectFit: "contain" }}
                    src={`${getApiBaseUrl()}/agents/${contact.agent.id}/profile-picture?auth=${token}&accountId=${
                      userAccount?.id
                    }`}
                    alt="Profile picture"
                  />
                ) : (
                  UserOutlined
                )
              }
            />
          ) : undefined
        }
        title={<Ellipsis style={{ fontSize: 16 }}>{contact.agent?.aggregatedName}</Ellipsis>}
        description={<Ellipsis>{contact.position}</Ellipsis>}
      />

      {children}
    </Card>
  );
};
